import { useQuery } from "@apollo/client/react";
import React, { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { adaptMotivoDemoraArray, GET_MOTIVOS_DEMORA } from '../../../data/graphQL/queries/Contratos/GestionInicio/getMotivosDemora';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';
import { toast } from 'react-hot-toast';

export const RegistroDemoraInput = ({
  idEvaluacion,
  handleClickAceptar,
  otherButtonsLoading
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [demora, setDemora] = useState({});
  const [motivosDemora, setMotivosDemora] = useState([]);

  const handleChange = (name, value) => {
    setDemora((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(false);
    setDemora({});
  };

  const disabledButtonAccept = () => {
    if (!demora.idMotivoDemora || !demora.observacion || !demora.fechaFinDemora) {
      toast.error('Debe completar los campos obligatorios');
      return true;
    }

    return false;
  };

  const handleOverrideClickAceptar = () => {
    if (disabledButtonAccept()) return;

    handleClickAceptar(demora);
    handleClose();
  };

  const newInput = useMemo(() => {
    return {
      displayName: 'Registrar Demora',
      name: 'registrarDemora',
      type: 'button',
      isLoading: otherButtonsLoading,
      variant: 'outlined',
      col: 30,
      onClick: () => handleOpenModal()
    };
  }, [otherButtonsLoading]);

  const { data: dataMotivosDemora } = useQuery(GET_MOTIVOS_DEMORA);

  useEffect(() => {
    if (!dataMotivosDemora) return;

    setMotivosDemora(adaptMotivoDemoraArray(dataMotivosDemora));
  }, [dataMotivosDemora]);

  const validatedInputs = useMemo(() => {
    return inputsValidar.map((input) => {
      switch (input.name) {
        case 'idMotivoDemora':
          input.options = motivosDemora;
          break;
        default:
          break;
      }

      return input;
    });
  }, [
    motivosDemora,
    demora,
    idEvaluacion]
  );

  return <>
    <RenderInputsRowByType
      input={newInput}
      value={null}
      handleChange={null} />

    <CustomDialog
      maxWidth='md'
      fullWidth
      onCancel={() => handleClose()}
      onAccept={() => handleOverrideClickAceptar()}
      open={openModal}
      cancelText='Cerrar'
      acceptText='Aceptar'
      title={'Registrar demora'}>

      <Grid
        container
        // justifyContent={'space-between'}
        columnSpacing={3}
        rowSpacing={3}
        columns={100}>

        {validatedInputs.map((input, index) => {
          return (
            <RenderInputsRowByType
              key={`name-${input.name}-index${index}`}
              input={input}
              value={demora[input.name]}
              handleChange={handleChange} />);


        })}
      </Grid>
    </CustomDialog>
  </>;
};

const inputsValidar = [
  {
    displayName: 'Fecha Fin Demora',
    name: 'fechaFinDemora',
    type: 'date',
    col: 30
  },
  {
    displayName: 'Motivo de demora',
    name: 'idMotivoDemora',
    type: 'select',
    col: 70
  },
  {
    displayName: 'Observacion extra',
    name: 'observacion',
    type: 'long_string',
    col: 100
  }];